// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ActorType,
  ChatMessageTag,
} from "./types";


export default __t.row({
  messageId: __t.u64().primaryKey().name("message_id"),
  sessionId: __t.u64().name("session_id"),
  senderIdentity: __t.identity().name("sender_identity"),
  senderName: __t.string().name("sender_name"),
  get senderActorType() {
    return ActorType.name("sender_actor_type");
  },
  content: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  editedAt: __t.option(__t.timestamp()).name("edited_at"),
  get tag() {
    return ChatMessageTag;
  },
});
